<div class="auth-body h-screen relative">
  <div class="absolute bottom-0 w-full flex justify-center flex-row">
    <div class="p-4 w-full bg-white">
      <p class="text-center text-[#797C83] footer-branding"> A Product by <b><a target="_blank" href="https://purple.lk/" class=" text-[#797C83] hover:font-[#640D5C]" style="">Purple Software</a></b></p>
    </div>
  </div>
  <div class="grid lg:grid-cols-2 h-full">
    <div class="bg-slate-200 hidden lg:flex items-center justify-end">
      <div class="bg-white h-4/6 w-8/12 p-1 drop-shadow-lg">
        <img
          class="h-full w-full object-cover"
          src="https://images.unsplash.com/photo-1655367382249-7598af406124?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
          alt="" />
      </div>
    </div>
    <div class="lg:bg-primary flex items-center justify-start">
      <div
        class="lg:bg-white w-full lg:h-4/6 lg:w-8/12 drop-shadow-lg flex items-center justify-center">
        <div class="w-8/12 lg:w-7/12 text-center lg:text-start">
          <div class="text-center" *ngIf="validating">
            <h5>Loading <span class="ml-3" nz-icon nzType="loading"></span></h5>
          </div>
          <nz-alert
            *ngIf="!forgotPasswordResponse?.done && !validating"
            nzType="error"
            [nzMessage]="forgotPasswordResponse?.message"
            nzShowIcon></nz-alert>
          <nz-card
            class="border-0"
            *ngIf="!validating && forgotPasswordResponse?.done">
            <form nz-form [formGroup]="changePwdForm">
              <h3>Reset Password</h3>
              <div class="flex flex-col items-stretch my-4">
                <nz-form-item class="mb-3">
                  <nz-form-control class="w-full" [nzErrorTip]="passwordError">
                    <nz-input-group
                      nzPrefixIcon="lock"
                      [nzSuffix]="newPasswordSuffixTemplate">
                      <input
                        nz-input
                        [type]="newPasswordVisible ? 'password' : 'text'"
                        formControlName="password"
                        placeholder="New Password"
                        required />
                    </nz-input-group>
                    <ng-template #newPasswordSuffixTemplate>
                      <i
                        class="cursor-on"
                        nz-icon
                        [nzType]="newPasswordVisible ? 'eye' : 'eye-invisible'"
                        (click)="newPasswordVisible = !newPasswordVisible"></i>
                    </ng-template>
                  </nz-form-control>
                  <ng-template #passwordError>
                    <span *ngIf="formErrors.password.required">
                      Please enter a new password
                    </span>
                    <span *ngIf="formErrors.password.pattern">
                      Password should more than 8 characters with at least one
                      capital letter, one number, one simple letter
                    </span>
                  </ng-template>
                </nz-form-item>
                <nz-form-item class="mb-3">
                  <nz-form-control
                    class="w-full"
                    [nzErrorTip]="confirmPasswordError">
                    <nz-input-group
                      nzPrefixIcon="lock"
                      [nzSuffix]="confirmPasswordSuffixTemplate">
                      <input
                        nz-input
                        [type]="confirmPasswordVisible ? 'password' : 'text'"
                        formControlName="confirmPassword"
                        placeholder="Confirm Password"
                        required />
                    </nz-input-group>
                    <ng-template #confirmPasswordSuffixTemplate>
                      <i
                        class="cursor-on"
                        nz-icon
                        [nzType]="
                          confirmPasswordVisible ? 'eye' : 'eye-invisible'
                        "
                        (click)="
                          confirmPasswordVisible = !confirmPasswordVisible
                        "></i>
                    </ng-template>
                  </nz-form-control>
                  <ng-template #confirmPasswordError>
                    <span *ngIf="formErrors.confirmPassword.required">
                      Confirm password is required
                    </span>
                    <span *ngIf="formErrors.confirmPassword.error">
                      Password is not matched
                    </span>
                  </ng-template>
                </nz-form-item>
              </div>
              <button
                nz-button
                nzType="primary"
                nzBlock
                (click)="change()"
                [disabled]="changePwdForm.invalid">
                Reset Password
              </button>
            </form>
          </nz-card>
        </div>
      </div>
    </div>
  </div>
</div>
